import type { AddTruckMakeInput, AddTruckModelInput, TruckMakeView, TruckModelView } from '@chukua/common';
import { api } from '../../../../shared/shared.api';

export type { TruckMakeView, TruckModelView };

export function listTruckMakes(): Promise<TruckMakeView[]> {
  return api<TruckMakeView[]>('/truck-makes');
}

export function addTruckMake(input: AddTruckMakeInput): Promise<TruckModelView> {
  return api<TruckModelView>('/truck-makes', { method: 'POST', body: JSON.stringify(input) });
}

export function addTruckModel(makeId: string, input: AddTruckModelInput): Promise<TruckModelView> {
  return api<TruckModelView>(`/truck-makes/${makeId}/models`, { method: 'POST', body: JSON.stringify(input) });
}
